import { MockedRequest, RestHandler, rest } from "msw";

import { Estimate } from "types/Estimate";

import { generateTestEstimate } from "../../tests/data";

export const buildEstimateGetResponse = (
  status: number,
  response: Estimate | null
): RestHandler<MockedRequest<Estimate | null>> => {
  return rest.get(`/client/:clientId/session/:sessionId/estimate`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json({ estimate: response }));
  });
};

export const estimateHandlers = [buildEstimateGetResponse(200, generateTestEstimate())];

